<template>
  <section>
    <div class="container">
      <div v-show="nezet.tipus == 'urlap'">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-title">
              Kiemelkedő tudományos, sport vagy kulturális tevékenységért járó ösztöndíj
            </div>
          </div>

          <div class="col-xs-12">
            <div class="info-box warning">
              Amennyiben hibát talál <span class="highlight">személyes</span> vagy <span class="highlight">képzési adataiban</span>, kérjük lépjen kapcsolatba a tanulmányi ügyintézővel.
            </div>
          </div>

          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Személyes adatok
            </h5>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="nev" name="nev" disabled label="Név" v-model="form.values.nev"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="neptunkod" name="neptunkod" disabled label="Neptun azonosító" v-model="form.values.neptunkod"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="szuletesiHely" name="szuletesiHely" disabled label="Születési hely" v-model="form.values.szuletesiHely"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="szuletesiIdo" name="szuletesiIdo" disabled label="Születési idő" v-model="form.values.szuletesiIdo"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="anyjaNeve" name="anyjaNeve" disabled label="Anyja neve" v-model="form.values.anyjaNeve"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="telefonszam" name="telefonszam" disabled label="Telefonszám" v-model="form.values.telefonszam"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="emailCim" name="emailCim" disabled label="E-mail cím" v-model="form.values.emailCim"/>
          </div>

          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Képzési adatok
            </h5>
          </div>
          <div class="col-xs-12">
            <comboboxV2 :errors="errors" @onChange="kepzesValt" label="Képzések" id="kepzesKodja" :options="kepzesek" v-model="form.values.kivalasztottKepzesKodja"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kar" name="kar" disabled label="Kar neve" v-model="form.values.kar"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="tagozat" name="tagozat" disabled label="Tagozat" v-model="form.values.tagozat"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kepzesNeve" name="kepzesNeve" disabled label="Képzés" v-model="form.values.kepzesNeve"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kepzesKodja" name="kepzesKodja" disabled label="Képzés kódja" v-model="form.values.kepzesKodja"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kepzesSzintje" name="kepzesSzintje" disabled label="Képzés szintje" v-model="form.values.kepzesSzintje"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="hallgatoiStatusz" name="hallgatoiStatusz" disabled label="Hallgatói státusz" v-model="form.values.hallgatoiStatusz"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kepzesHelye" name="kepzesHelye" disabled label="Képzés helye" v-model="form.values.kepzesHelye"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="penzugyiStatusz" name="penzugyiStatusz" disabled label="Pénzügyi státusz" v-model="form.values.penzugyiStatusz"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="osztondijindex" name="osztondijindex" disabled label="Ösztöndíjindex" v-model="form.values.osztondijindex"/>
          </div>
          <div class="col-xs-12">
            <inputbox regexp_filter="[0-9]+" :errors="errors" id="felevekSzama" name="felevekSzama" label="Hányadik félévedet töltöd az egyetemen?" v-model="form.values.felevekSzama"/>
          </div>
        </div>

        <div class="row" :class="{'grid-row-disabled': parseInt(form.values.felevekSzama) <= 1 || form.values.felevekSzama == ''}">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Kiemelkedő tehetséggondozási tevékenységért járó ösztöndíj
            </h5>
          </div>

          <div class="col-xs-12">
            <div class="info-box warning">
              Tehetséggondozó műhely: A hallgató benyújthatja, ha tagja egy versenycsapatnak vagy egy szakkollégiumnak, helyezést ért el a legutóbbi TDK-n vagy OTDK-n, részt vett más szakmai versenyen, illetve publikációt jelentetett meg.
            </div>
          </div>
          <div class="col-xs-12">
            <inputbox :errors="errors" id="tudomanyosTevekenyseg" name="tudomanyosTevekenyseg" label="Milyen tevékenységet folytat?" v-model="form.values.tudomanyosTevekenyseg"/>
          </div>
          <div class="col-xs-4">
            <inputbox :errors="errors" id="tudomanyosElertEredmeny" name="tudomanyosElertEredmeny" label="Elért eredmény" v-model="form.values.tudomanyosElertEredmeny"/>
          </div>
          <div class="col-xs-4">
            <inputbox :errors="errors" id="tudomanyosVersenyMegnevezese" name="tudomanyosVersenyMegnevezese" label="Verseny megnevezése" v-model="form.values.tudomanyosVersenyMegnevezese"/>
          </div>
          <div class="col-xs-4">
            <inputbox :errors="errors" id="tudomanyosElertHelyezes" name="tudomanyosElertHelyezes" label="Elért helyezés" v-model="form.values.tudomanyosElertHelyezes"/>
          </div>
          <div class="col-xs-12">
            <div class="info-box warning">
              Amennyiben verseny csapatban tevékenykedik
            </div>
          </div>
          <div class="col-xs-4">
            <inputbox :errors="errors" id="tudomanyosVersenyCsapatnev" name="tudomanyosVersenyCsapatnev" label="Versenycsapat neve" v-model="form.values.tudomanyosVersenyCsapatnev"/>
          </div>
          <div class="col-xs-4">
            <inputbox :errors="errors" id="tudomanyosVersenyCsapatBetoltottPozicio" name="tudomanyosVersenyCsapatBetoltottPozicio" label="Betöltött pozíció" v-model="form.values.tudomanyosVersenyCsapatBetoltottPozicio"/>
          </div>
          <div class="col-xs-4">
            <inputbox :errors="errors" id="tudomanyosVersenyCsapatTagsagKezdete" name="tudomanyosVersenyCsapatTagsagKezdete" label="Tagság kezdete (félévre nézve)" v-model="form.values.tudomanyosVersenyCsapatTagsagKezdete"/>
          </div>
          <div class="col-xs-12">
            <inputbox :errors="errors" id="tudomanyosEgyetemJoHire" name="tudomanyosEgyetemJoHire" label="Tevékenységével hogyan és mi módon gyarapította az Egyetem jó hírét?" v-model="form.values.tudomanyosEgyetemJoHire"/>
          </div>

          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Kiemelkedő kulturális tevékenységért járó ösztöndíj
            </h5>
          </div>
          <div class="col-xs-12">
            <div class="info-box warning">
              A hallgató benyújthatja, ha kiemelkedően teljesít képzőművészet, zenekari és szóló hangszerek területén.
            </div>
          </div>
          <div class="col-xs-12">
            <inputbox :errors="errors" id="kulturalisTevekenyseg" name="kulturalisTevekenyseg" label="Milyen tevékenységet folytat?" v-model="form.values.kulturalisTevekenyseg"/>
          </div>
          <div class="col-xs-12">
            <inputbox regexp_filter="[0-9]+" :errors="errors" id="kulturalisTevekenysegEvszam" name="kulturalisTevekenysegEvszam" label="Mióta végzi a tevékenységet? (évszámra pontosan)" v-model="form.values.kulturalisTevekenysegEvszam"/>
          </div>
          <div class="col-xs-4">
            <inputbox :errors="errors" id="kulturalisElertEredmeny" name="kulturalisElertEredmeny" label="Elért eredmény" v-model="form.values.kulturalisElertEredmeny"/>
          </div>
          <div class="col-xs-4">
            <inputbox :errors="errors" id="kulturalisMegmerettetesMegnevezese" name="kulturalisMegmerettetesMegnevezese" label="Megmérettetés megnevezése" v-model="form.values.kulturalisMegmerettetesMegnevezese"/>
          </div>
          <div class="col-xs-4">
            <inputbox :errors="errors" id="kulturalisElertHelyezes" name="kulturalisElertHelyezes" label="Elért helyezés" v-model="form.values.kulturalisElertHelyezes"/>
          </div>
          <div class="col-xs-12">
            <inputbox :errors="errors" id="kulturalisEgyetemJoHire" name="kulturalisEgyetemJoHire" label="Tevékenységével hogyan és mi módon gyarapította az Egyetem jó hírét?" v-model="form.values.kulturalisEgyetemJoHire"/>
          </div>

          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Kiemelkedő sport tevékenységért járó ösztöndíj
            </h5>
          </div>
          <div class="col-xs-12">
            <div class="info-box warning">
              A hallgató benyújthatja, ha kiemelkedően teljesít klasszikus sport és az e-sport területén.
            </div>
          </div>
          <div class="col-xs-12">
            <inputbox :errors="errors" id="sportTevekenyseg" name="sportTevekenyseg" label="Milyen tevékenységet folytat?" v-model="form.values.sportTevekenyseg"/>
          </div>
          <div class="col-xs-12">
            <inputbox regexp_filter="[0-9]+" :errors="errors" id="sportTevekenysegEvszam" name="sportTevekenysegEvszam" label="Mióta végzi a tevékenységet? (évszámra pontosan)" v-model="form.values.sportTevekenysegEvszam"/>
          </div>
          <div class="col-xs-12">
            <div class="info-box warning">
              Elért sporteredmények
            </div>
          </div>
          <div class="col-xs-12">
            <table class="list-table" v-show="form.values.sportVersenyek.length > 0">
              <tr>
                <th align="left">Verseny dátuma</th>
                <th align="left">Verseny megnevezése</th>
                <th align="left">Helyezés</th>
                <th align="left">Milyen szinten elért eredmény?</th>
                <th></th>
              </tr>
              <tr :key="'sv_'+i" v-for="(sv, i) in form.values.sportVersenyek">
                <td>
                  <inputbox :datepicker="true" style="padding-bottom: 0px" :errors="errors" :id="'sv_datum_'+i" label="" :name="'sv_datum_'+i" v-model="sv.datum"/>
                </td>
                <td>
                  <inputbox style="padding-bottom: 0px" :errors="errors" :id="'sv_megnevezes_'+i" label="" :name="'sv_megnevezes_'+i" v-model="sv.megnevezes"/>
                </td>
                <td>
                  <inputbox regexp_filter="[0-9]+" style="padding-bottom: 0px" :errors="errors" :id="'sv_helyezes_'+i" label="" :name="'sv_helyezes_'+i" v-model="sv.helyezes"/>
                </td>
                <td>
                  <comboboxV2 style="padding-bottom: 0px" :errors="errors" label="" :id="'sv_szint_'+i" :options="verseny_szintek" v-model="sv.szint"/>
                </td>
                <td>
                  <button @click="versenyTorol(i)" type="button" class="button only-icon"><i class="fa fa-trash"></i></button>
                </td>
              </tr>
            </table>
            <div class="form-group">
              <button :disabled="form.values.sportVersenyek.length >= 9" @click="versenyHozzaad" type="button" class="button only-icon">+</button>
            </div>
          </div>
          <div class="col-xs-12">
            <inputbox :errors="errors" id="sportEgyetemJoHire" name="sportEgyetemJoHire" label="Tevékenységével hogyan és mi módon gyarapította az Egyetem jó hírét?" v-model="form.values.sportEgyetemJoHire"/>
          </div>

          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Hallgatói nyiltakozat
            </h5>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input true-value="1" false-value="0" id="nyilatkozatElfogadas" type="checkbox" v-model="form.values.nyilatkozatElfogadas"/>
                <label for="nyilatkozatElfogadas">
                  <div class="icon"></div>
                  A pályázat benyújtásával büntetőjogi felelősségem teljes tudatában kijelentem, hogy hamis adatok közlése esetén fegyelmi eljárás indulhat ellenem, mely a hallgatói jogviszony fegyelmi úton történő megszüntetését is eredményezheti. Továbbá hozzájárulok ahhoz, hogy adataimat a Széchenyi István Egyetem Hallgatói Önkormányzata nevében eljáró személyek a pályázat elbírálásával összefüggésben, a TJSZ-ben rögzített feltételeknek, illetve a személyi adatok védelméről és a közérdekű adatok nyilvánosságáról szóló 1992. évi LXIII. törvénynek megfelelően kezelje.
                </label>
              </div>
              <div v-if="error.id == 'nyilatkozatElfogadas'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
            </div>
          </div>

          <div class="col-xs-12">
            <div style="display: flex; justify-content: space-between; align-items: center">
              <button v-on:click="save(0)" :disabled="mentes_folyamatban" type="button" class="button">Mentés</button>
              <button v-on:click="saveConfirm(1)" :disabled="mentes_folyamatban" type="button" class="button">Véglegesít</button>
            </div>
          </div>
        </div>
      </div>

      <div v-show="nezet.tipus == 'info'">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-title">
              Kiemelkedő tudományos, sport vagy kulturális tevékenységért járó ösztöndíj
            </div>
            <div class="article-text" v-html="nezet.tartalom"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';

export default {
  data: function() {
    return {
      form: {
        id: 0,
        values: {
          nev: '',
          neptunkod: '',
          szuletesiHely: '',
          szuletesiIdo: '',
          anyjaNeve: '',
          telefonszam: '',
          emailCim: '',
          kar: '',
          tagozat: '',
          kepzesNeve: '',
          kepzesSzintje: '',
          kepzesKodja: '',
          kepzesHelye: '',
          penzugyiStatusz: '',
          hallgatoiStatusz: '',
          osztondijindex: 0,
          nyilatkozatElfogadas: 0,
          kivalasztottKepzesKodja: '',
          felevekSzama: '',
          tudomanyosTevekenyseg: '',
          tudomanyosElertEredmeny: '',
          tudomanyosVersenyMegnevezese: '',
          tudomanyosElertHelyezes: '',
          tudomanyosVersenyCsapatnev: '',
          tudomanyosVersenyCsapatBetoltottPozicio: '',
          tudomanyosVersenyCsapatTagsagKezdete: '',
          tudomanyosEgyetemJoHire: '',
          kulturalisTevekenyseg: '',
          kulturalisTevekenysegEvszam: '',
          kulturalisElertEredmeny: '',
          kulturalisMegmerettetesMegnevezese: '',
          kulturalisElertHelyezes: '',
          kulturalisEgyetemJoHire: '',
          sportTevekenyseg: '',
          sportTevekenysegEvszam: '',
          sportVersenyek: [],
          sportEgyetemJoHire: ''
        }
      },
      kepzesek: [],
      errors: [],
      verseny_szintek: [
        {value: 'válogatott/nemzetközi', label: 'válogatott/nemzetközi'},
        {value: 'egyesületi', label: 'egyesületi'},
        {value: 'egyetemi', label: 'egyetemi'}
      ],
      mentes_folyamatban: false,
      nezet: {
        tipus: 'info',
        tartalom: ''
      }
    }
  },

  mounted: function() {
    this.init();
  },

  methods: {
    init() {
      const _this = this;

      this.nezet.tipus = 'info';
      this.nezet.tartalom = 'Adatok betöltése folyamatban...';

      this.$root.ajax('form/kiemelkedo_tudomanyos_sport_kulturalis_osztondij/'+this.$route.query.id, {
        method: 'get',
        success: function(response) {
          _this.nezet.tipus = 'urlap';

          if (response.exception_error != false) {
            _this.nezet.tipus = 'info';
            _this.nezet.tartalom = response.exception_error;
            return;
          }

          _this.form.id = _this.$route.query.id;

          if (response.kepzesek != undefined) {
            _this.kepzesek = response.kepzesek;
            _this.form.values.kivalasztottKepzesKodja = _this.kepzesek[0].value;
            _this.kepzesValt();
          }

          if (response.fill != false) {
            if (response.fill.status == 'Mentve') {
              _this.form.values = Object.assign({}, _this.form.values, response.fill.values);
              _this.form.values.kivalasztottKepzesKodja = response.fill.values.kepzesKodja;

            } else if (['Nyertes', 'Nem nyertes', 'Kizárva', 'Érvénytelen'].includes(response.fill.status)) {
              _this.nezet.tipus = 'info';
              _this.nezet.tartalom = '<div>Az Ön által beküldött pályázata az alábbi <a target="_blank" href="assets/urlap_kitoltesek/' + response.fill.pdf_filename + '">linkre</a> kattintva tekinthető meg.</div>';
              _this.nezet.tartalom += '<div>Az elbírált pályázat (' + response.fill.status + ') az alábbi <a target="_blank" href="assets/urlap_kitoltesek/' + response.fill.modify_pdf_filename + '">linkre</a> kattintva tekinthető meg.</div>';
            } else {
              _this.nezet.tipus = 'info';
              _this.nezet.tartalom = 'Az Ön által beküldött pályázata az alábbi <a target="_blank" href="assets/urlap_kitoltesek/' + response.fill.pdf_filename + '">linkre</a> kattintva tekinthető meg.';
            }
          }
        }
      });
    },

    saveConfirm: function(veglegesit) {
      const _this = this;

      swal({
        title: "Biztos véglegesíti a pályázatot?",
        text: "A pályázat véglegesítés után változtatni már nem lehetséges!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Mégsem",
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: false
      }, function(isConfirm) {
        if (isConfirm) {
          _this.save(veglegesit);
        }
      });
    },

    save: function(veglegesit) {
      var _this = this;

      this.errors = [];
      this.form.id = this.$route.query.id;
      _this.mentes_folyamatban = true;

      this.$root.ajax('form/kiemelkedo_tudomanyos_sport_kulturalis_osztondij_mentes/', {
        method: 'POST',
        data: {
          form: JSON.stringify(this.form),
          veglegesit: veglegesit
        },
        success: function(response) {
          _this.mentes_folyamatban = false;

          if (response.exception_error != false) {
            _this.nezet.tipus = 'info';
            _this.nezet.tartalom = response.exception_error;
            return;
          }

          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            });

            return false;
          }

          _this.nezet.tipus = 'info';
          _this.nezet.tartalom = response.info;
        }
      });
    },

    kepzesValt() {
      const _this = this;

      this.kepzesek.map((kepzes) => {
        if (kepzes.kepzesKodja == _this.form.values.kivalasztottKepzesKodja) {
          _this.form.values.kar = kepzes.kar;
          _this.form.values.tagozat = kepzes.tagozat;
          _this.form.values.kepzesNeve = kepzes.kepzesNeve;
          _this.form.values.kepzesSzintje = kepzes.kepzesSzintje;
          _this.form.values.kepzesKodja = kepzes.kepzesKodja;
          _this.form.values.kepzesHelye = kepzes.kepzesHelye;
          _this.form.values.penzugyiStatusz = kepzes.penzugyiStatusz;
          _this.form.values.hallgatoiStatusz = kepzes.hallgatoiStatusz;
          _this.form.values.osztondijindex = kepzes.osztondijindex == null ? 0 : kepzes.osztondijindex;
          _this.form.values.nev = kepzes.nev;
          _this.form.values.neptunkod = kepzes.neptunkod;
          _this.form.values.szuletesiHely = kepzes.szuletesiHely;
          _this.form.values.szuletesiIdo = kepzes.szuletesiIdo;
          _this.form.values.anyjaNeve = kepzes.anyjaNeve;
          _this.form.values.telefonszam = kepzes.telefonszam == null ? '' : kepzes.telefonszam;
          _this.form.values.emailCim = kepzes.emailCim == null ? '' : kepzes.emailCim;
        }
      });
    },

    versenyHozzaad() {
      this.form.values.sportVersenyek.push({
        datum: '',
        megnevezes: '',
        helyezes: '',
        szint: this.verseny_szintek[0].value
      });
    },

    versenyTorol(index) {
      this.form.values.sportVersenyek.splice(index, 1);
    }
  }
}
</script>


// WEBPACK FOOTER //
// kiemelkedo_tudomanyos_sport_kulturalis_osztondij.vue?13e85eae